import * as R from 'ramda';

import store from '../store/store';
import notificationActions from '../actions/notifications';
import errorDictionary from './errorDictionary';
import { sportsApiUrl } from './apiUrls';
import { createRejectingUnauthorizedHandler } from './requestErrorHandlers';
import wretch from './wretch';
import logoutAction from '../actions/user/logout';

const logout = store.action(logoutAction(store));

const notifications = notificationActions(store);
const sendNotification = store.action(notifications.send);

let clientId = null;
let isSSOUser = null;

store.subscribe(state => {
    clientId = state.user.selectedClientId;
    isSSOUser = state.user.ssoLogin;
});

const notifyErrors = (error, request) => {
    const { message, notificationLevel } = parseErrorMessage(error);
    sendNotification(message, { context: notificationLevel });
    return request;
};

const handleUnauthorized = createRejectingUnauthorizedHandler({
    onNotify: notifyErrors,
    onLogout: logout,
});

const parseErrorMessage = error => {
    const errorJSON = error.text ? JSON.parse(error.text) : {};
    const currentMessage =
        R.path(['message'], errorJSON) || 'Something went wrong.';
    return (
        errorDictionary[currentMessage] || {
            message: currentMessage,
            notificationLevel: 'danger',
        }
    );
};

// Use this to test against local S-API
// const API_URL = 'http://localhost:8080/v1';

export const API_URL = sportsApiUrl;

function defer(w, url, { method, body = '{}', context }) {
    if (
        context?.ssoBootstrap === true ||
        !url.startsWith(API_URL) ||
        !clientId ||
        url.includes('noClientId')
    )
        return w;

    if (
        url.includes('mvc-global-filters') &&
        (method === 'POST' || method === 'PUT' || method === 'PATCH')
    ) {
        const bodyJson = JSON.parse(body) || {};
        bodyJson.domainObject.clientId = clientId;
        return w.json(bodyJson);
    }

    if (method === 'GET' || method === 'DELETE') {
        return w.query({ clientId });
    }

    if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
        const bodyJson = JSON.parse(body) || {};
        if (bodyJson.domainObject) {
            bodyJson.domainObject.client = { id: clientId };
        } else {
            bodyJson.client = { id: clientId };
        }

        return w.json(bodyJson);
    }
}

export const baseSportsApi = wretch.defer(defer);

const sportsApi = baseSportsApi
    .resolve(_ =>
        _.badRequest((err, req) => notifyErrors(err, req))
            .unauthorized(handleUnauthorized)
            .forbidden((err, req) => notifyErrors(err, req))
            .notFound((err, req) => notifyErrors(err, req))
            .timeout((err, req) => notifyErrors(err, req))
            .internalError((err, req) => notifyErrors(err, req))
            .error(409, (err, req) => notifyErrors(err, req))
            .error(400, (err, req) => notifyErrors(err, req)),
    )
    .url(API_URL);

if (isSSOUser) {
    baseSportsApi.options({ credentials: 'include' });
}

export default sportsApi;
